import React, { useEffect, useState } from "react";
import Wrapper from "./shared/Wrapper";
let resolution = window.RESOLUTION;

const Keyboard = ({
  keys,
  onKeyPress,
  onClear,
  shouldFocus,
  selectionColor = "#FF671F",
  callBack,
  onFocusNeeded,
}) => {
  const [selectedKey, setSelectedKey] = useState({ row: 0, col: 0 });
  console.log(keys,"Keys")

  const appLanguage = localStorage.getItem("AppLanguage")

  const isSpecialLanguage = ["Malyalam","Telgu","Tamil","Kannada"].includes(appLanguage)

  useEffect(() => {
    const handleKeyDown = (event) => {
      switch (event.keyCode) {
        case 38:
          setSelectedKey((prev) => ({
            row: Math.max(prev.row - 1, 0),
            col: prev.col,
          }));
          break;
        case 40:
          setSelectedKey((prev) => {
            let newRow = prev.row;
            let newCol = prev.col;
            if (prev.row === keys.length - 2) {
              if (prev.col === 0 || prev.col === 1) {
                newCol = 0; // SPACE button
              } else if (prev.col === 2 || prev.col === 3) {
                newCol = 1; // Del button
              } else if (prev.col === 4 || prev.col === 5) {
                newCol = 2; // Clear button
              }
              newRow = keys.length - 1;
            } else {
              newRow = Math.min(prev.row + 1, keys.length - 1);
            }
            return { row: newRow, col: newCol };
          });
          break;
        case 37:
          if (selectedKey.col <= 0 && selectedKey.row < 7) {
            callBack("Back");
            // console.log("selectedKey..", selectedKey);
          } else {
            setSelectedKey((prev) => ({
              row: prev.row,
              col: Math.max(prev.col - 1, 0),
            }));
          }
          // console.log("selectedKey..", selectedKey);
          break;
        case 39:
          // console.log("selectedKey --- = ",selectedKey);
          if (selectedKey.col < 5 && selectedKey.row < 6) {
            setSelectedKey((prev) => ({
              row: prev.row,
              col: Math.min(prev.col + 1, keys[0].length - 1),
            }));
            // console.log("selectedKey..", selectedKey);
          } else if (selectedKey.col == 5 && selectedKey.row < 6) {
            callBack("keyboard");
          } else if (selectedKey.row == 6) {
            if (selectedKey.col < 2) {
              setSelectedKey((prev) => ({
                row: prev.row,
                col: Math.min(prev.col + 1, keys[0].length - 1),
              }));
            } else {
              callBack("keyboard");
            }
          }
          break;
        case 13:
          const key = keys[selectedKey.row][selectedKey.col];
          if (key === "Clear") {
            onClear();
          } else {
            onKeyPress(key);
          }
          break;
        case 8:
          callBack("Back");
          break;
        case 10009:
          callBack("Back");
          break;
        case 461:
          callBack("Back");
          break;
        default:
          break;
      }
    };

    if (shouldFocus) {
      window.addEventListener("keydown", handleKeyDown);
    } else {
      window.removeEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedKey, keys, onKeyPress, onClear, shouldFocus, callBack]);

  const handleMouseEnter = (rowIndex, colIndex) => {
    if (shouldFocus) {
      setSelectedKey({ row: rowIndex, col: colIndex });
    }
  };

  const handleMouseLeave = () => {
  if (shouldFocus) {
    setSelectedKey({ row: -1, col: -1 });
  }
};

  return (
    <div style={styles.keyboardContainer} onMouseEnter={onFocusNeeded}>
      {keys.map((row, rowIndex) => (
        <div key={rowIndex} style={styles.row}>
          {row.map((key, colIndex) => (console.log("key", key),
            <Wrapper
              key={key}
              // className={"scroll-text"}
              style={{
                ...styles.key,
                fontFamily: "Anek Latin", 
                fontSize: "50px", 
               width: key == "SPACE" || key == "DEL" || key == "CLEAR"|| key == 'space' || key == 'del' || key == 'clear' ? '184px' : '85px',
                backgroundColor:
                  selectedKey.row === rowIndex && selectedKey.col === colIndex
                    ? selectionColor
                    : "#0E1653",
              }}
              onMouseEnter={() => {
                setSelectedKey({ row: rowIndex, col: colIndex });
              }}
              onClick={() => (key === "Clear" ? onClear() : onKeyPress(key))}
           
            >
              {key}
            </Wrapper>
          ))}
        </div>
      ))}
    </div>
  );
};

const styles = {
  keyboardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    margin: resolution === "FHD" ? "5px 0" : "3px 0",
  },
  key: {
    height: resolution === "FHD" ? "85px" : "43px",
    margin: resolution === "FHD" ? "7px" : "5px",
    backgroundColor: "#333",
    color: "#fff",
    fontSize: resolution === "FHD" ? "42px" : "42px",
    border: "none",
    borderRadius: resolution === "FHD" ? "5px" : "3px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Anek Latin", 
  },
};

export default Keyboard;
